import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { formatearFecha ,formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';


class FormAdmin01 extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            permiso: null,

            //DatePicker
            fechaOriginal: null,
            fechaMod: null,

            //checkbox
            normalizarFecha: false,

            //Aux
            autorizacion: false,

            //SELECT
            modulos_opt: [],
            modulos_sel: null,
        }; 
        //OVERCONTROLS
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.changeModulo = this.changeModulo.bind(this);
        this.limpiar = this.limpiar.bind(this);

        //ACTION BUTTON
        this.guardarFechaMod = this.guardarFechaMod.bind(this);
    }

    //OverControls
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });

        if(name==='normalizarFecha' && value ===true){
            this.setState({fechaMod: null})
        }        
    }

    changeModulo(value){
        this.setState({modulos_sel: value!==null?value:null})

        if(value!==null){
            if(value.FechaProceso===null){
                console.log("FECHA PRO: ",this.props.fechaProceso)
                this.setState({fechaOriginal: moment(this.props.fechaProceso, 'DD/MM/YYYY')})
            }else{
                var fecha = new Date(value.FechaProceso).toISOString().substring(0,10)
                this.setState({fechaOriginal: moment(formatearFecha(fecha), 'DD/MM/YYYY')})
            }
        }else{
            this.setState({fechaOriginal: null})
        }
        
    }
    
    //Consulta DB
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }


    //Action Buttons

    guardarFechaMod(){
        var errors = "";
        var proceder = true;
        var data = {};

        if(this.state.modulos_sel===null){
            proceder = false;
            errors = errors+'- Seleccione un modulo a modificar.\n'
        }else if(this.state.modulos_sel!==null&&(this.state.fechaMod===null && this.state.normalizarFecha===false)){
            proceder = false;
            errors = errors+'- Seleccione fecha a modificar.\n'
        }else if(this.state.modulos_sel!==null && this.state.normalizarFecha===true && this.state.fechaMod!==null){
            proceder = false;
            errors = errors+'- No se puede restablecer la fecha proceso de un modulo con el campo fecha nueva lleno.\n'
        }

        if(proceder === true){

            if(this.state.fechaMod!==null){
                data.fechaMod = formatearFechaMoment_a_String(this.state.fechaMod);
            }

            data.normalizar = this.state.normalizarFecha;
            data.modulo = this.state.modulos_sel.value;

            let config_request = {
                method: 'PATCH',
                url: '/modulosporusuario/'+data.modulo,
                data
            }

            global_axios(config_request)
            .then((response)=> {             
                alert(response.data.msg);
                this.limpiar();
                this.actualizarFechasPorModulo(this.props.usuario)
                
            })
            .catch((error)=>{
                this.actualizarFechasPorModulo(this.props.usuario)                  
                alert(error.response?error.response.data.msg:error.message);                
            });

        }else{
            alert(errors)
        }
    }

    limpiar(){
        this.setState({fechaMod: null, fechaOriginal:null, normalizarFecha: false, modulos_sel: null})
    }

    //REACT CYCLE
    componentDidMount(){
        Promise.all([            
            this.props.generar_LogAuditoriaIngresoForm('1001'), ])
        .then(() => {   
            this.setState({permiso: this.props.permiso})

            this.actualizarFechasPorModulo(this.props.usuario)
            //let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");        
        });
    }

    actualizarFechasPorModulo(usuario){
        this.cargarObjetos('/modulosporusuario?usuario='+usuario).then((result_Modulo)=>{
            console.log("RESULTADO: ", result_Modulo)
            
            var resultModulo = [];
            
            result_Modulo.forEach((MOD)=>{
                var item = {};
                item.value = MOD.Codigo;
                item.label = MOD.Descripcion.toString().toUpperCase();
                item.FechaProceso = MOD.FechaProceso;

                resultModulo.push(item);
            })

            this.setState({autorizacion: true, modulos_opt: resultModulo})

        }).catch((error)=>{
            this.setState({autorizacion: false})
            alert(error.response?error.response.data.msg:error.message); 
        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('1001');
    }

    render(){
        return(
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Modificación de fecha proceso</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo='2'>
                        <Row>
                            <ContainerCol className='col-sm-3 col-sm-offset-9 col-sm-pull-9'>
                                <LabelForm>Modulos:</LabelForm>
                                <ReactSelect options={ this.state.modulos_opt } value={this.state.modulos_sel} func_onChange={(value)=>{this.changeModulo(value)}}/>
                            </ContainerCol>    
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>
                            <Row>
                                <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='8'>
                                    <LabelForm>Actual:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaOriginal} disabled={true} func_onChange={(fechaEscogida)=>{this.setState({fechaOriginal: fechaEscogida});}}/>
                                </ContainerCol>

                                <ContainerCol className='col-sm-4 col-sm-offset-1 col-sm-pull-1' margen_arriba='15' margen_abajo='4'>
                                    <LabelForm><input type='checkbox' name='normalizarFecha' checked={this.state.normalizarFecha} 
                                    onChange={this.actualizarCampos}/> Normalizar fecha</LabelForm> 
                                </ContainerCol>
                            </Row>                            
                            
                            <Row>
                                <ContainerCol className='col-sm-2' margen_abajo='4'>
                                    <LabelForm>Nueva:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaMod} disabled={this.state.modulos_sel===null?true:false} func_onChange={(fechaEscogida)=>{this.setState({fechaMod: fechaEscogida});}}/>
                                </ContainerCol>
                            </Row>
                            
                        </ContainerCol>  
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.autorizacion===false?true:false} onClick={this.guardarFechaMod}><i className="fa fa-floppy-o fa-lg" aria-hidden="true"/> Guardar</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>            
        )   
    }
}

const mapStateToProps = ((state) => {
    return {fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            departamento : state.sesion.valoresSesionForm.Departamento
        }
  });
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, 
                            cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormAdmin01);